import { createContext, useMemo, useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

export const ColorModeContext = createContext();

export default function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState(
    localStorage.getItem("themeMode") || "dark"
  );

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prev) => {
          const newMode = prev === "light" ? "dark" : "light";
          localStorage.setItem("themeMode", newMode);
          return newMode;
        });
      },
    }),
    []
  );

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,

          ...(mode === "dark"
            ? {
                background: {
                  default: "#0B1120",
                  paper: "#071120",
                },

                text: {
                  primary: "#E2E8F0",
                  secondary: "#94A3B8",
                },
              }
            : {
                background: {
                  default: "#F8FAFC",
                  paper: "#FFFFFF",
                },

                text: {
                  primary: "#111827",
                  secondary: "#6B7280",
                },
              }),
        },
        components: {
          MuiTab: {
            styleOverrides: {
              root: {
                textTransform: "none",
              },
            },
          },
        },
      }),
    [mode]
  );

  return (
    <ColorModeContext.Provider value={{ colorMode, mode }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}